import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: "Best In Class",
  date: new Date(2025, 7, 10),
  img: "/img/raincoat.jpeg",
  tracks: [
    {
      title: "Asking For A Friend",
      src: "/songs/2025-08-10/asking_for_a_friend.mp3",
      duration: 1059.864,
    },
    {
      title: "As Above So Below",
      src: "/songs/2025-08-10/as_above_so_below.mp3",
      duration: 679.104,
    },
    {
      title: "You'll Know It When You See It",
      src: "/songs/2025-08-10/youll_know_it_when_you_see_it.mp3",
      duration: 673.296,
    },
    {
      title: "Sexy Raincoat",
      src: "/songs/2025-08-10/sexy_raincoat.mp3",
      duration: 658.128,
    },
    {
      title: "Dancing Bird People",
      src: "/songs/2025-08-10/dancing_bird_people.mp3",
      duration: 547.416,
    },
    {
      title: "Throwing In The Towel",
      src: "/songs/2025-08-10/throwing_in_the_towel.mp3",
      duration: 565.08,
    },
  ],
};
export default album;
